import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { InvitationSandbox } from './invitation.sandbox';
import { Route } from '../core/enums/route.enum';

export const validateInvitationGuard = (): Observable<boolean | UrlTree> => {
  const invitationSandbox = inject(InvitationSandbox);
  const invitationCode = invitationSandbox.invitationCode();
  const router = inject(Router);

  if (!invitationCode) {
    return of(true);
  } else {
    return invitationSandbox.verifyInvitation(invitationCode).pipe(
      switchMap((invitation) => {
        if (invitation.isValid) {
          return invitationSandbox.linkUser(invitation.invitationId).pipe(
            map(() => router.createUrlTree([Route.Home])),
            catchError(() => of(true))
          );
        } else {
          return of(true);
        }
      })
    );
  }
}